import * as React from "react";
import { useEffect } from "react";
import ScrollBar from "react-perfect-scrollbar";
import { connect } from "react-redux";
import { ScrollOptions } from "../../../../constants/ScrollOptions";
import { IdStyles } from "../../../../less/IdStyles";
import { selectQuestInfo, selectSelectedQuest, selectSortedQuest, } from "../../../../selectors/selectQuestInfo";
import { ButtonPrimaryMedium } from "../../../generic/common/ButtonPrimaryMedium";
import { ButtonQuestRecommended } from "../../../generic/common/ButtonQuestRecommended";
import { ButtonQuestTimeChallenge } from "../../../generic/common/ButtonQuestTimeChallenge";
import { ButtonSecondaryAccentLarge } from "../../../generic/common/ButtonSecondaryAccentLarge";
import { actionQuestSelect } from "./actionQuests";
import { QuestButton } from "./QuestButton";
var refToListContainer;
var QuestListDOM = function (_a) {
    var recommendedQuest = _a.recommendedQuest, quests = _a.quests, onQuestSelect = _a.onQuestSelect, recommendedQuestId = _a.recommendedQuestId, selectedQuestId = _a.selectedQuestId;
    var className = "";
    var refToListItem = React.createRef();
    useEffect(function () {
        var selectedElement = refToListItem.current;
        if (!!selectedElement && !!refToListContainer) {
            var refOffsetTop = selectedElement.offsetTop - refToListContainer.scrollTop;
            var shouldScrollToQuestBtn = !(refOffsetTop > -1 && refOffsetTop < refToListContainer.clientHeight);
            if (selectedQuestId && selectedQuestId > 0 && shouldScrollToQuestBtn) {
                refToListContainer.scrollTop =
                    selectedElement.offsetTop - refToListContainer.offsetTop;
            }
        }
    }, [selectedQuestId]);
    var getQuestButtons = function () {
        return quests.map(function (value) { return getQuestButton(value); });
    };
    var getButtonState = function (isQuestCompleted, isQuestRecommended, isQuestTimeChallenge) {
        if (isQuestCompleted) {
            return ButtonPrimaryMedium;
        }
        else if (isQuestTimeChallenge) {
            return ButtonQuestTimeChallenge;
        }
        else if (isQuestRecommended) {
            return ButtonQuestRecommended;
        }
        return ButtonSecondaryAccentLarge;
    };
    var getQuestButton = function (quest) {
        var selectedItemRef = selectedQuestId === quest.id ? refToListItem : undefined;
        return (React.createElement("div", { className: "quest-button", ref: selectedItemRef, key: quest.id },
            React.createElement(QuestButton, { quest: quest, iconStyle: IdStyles.IconLarge, showSelectedQuest: true, onClick: onQuestSelect, getButton: getButtonState, recommendedQuestId: recommendedQuestId, renderTooltips: false })));
    };
    var questButtons = getQuestButtons();
    var recommendedQuestButton = recommendedQuest ? getQuestButton(recommendedQuest) : undefined;
    return (React.createElement("div", { className: "quest-buttons " + className },
        React.createElement("div", { className: "quest-buttons_recommended" }, recommendedQuestButton),
        React.createElement("div", { className: "quest-buttons_divider" }),
        React.createElement("div", { className: "quest-buttons_list" },
            React.createElement(ScrollBar, { component: "div", options: ScrollOptions, className: "w100", containerRef: function (ref) { return (refToListContainer = ref); } },
                React.createElement("div", { className: "flex flex--aligned flex--stacked" }, questButtons)))));
};
var mapState = function (state) {
    var selectedQuest = selectSelectedQuest(state);
    var selectedQuestId = -1;
    if (selectedQuest) {
        selectedQuestId = selectedQuest.id;
    }
    var quests = selectSortedQuest(state);
    var _a = selectQuestInfo(state), recommendedQuest = _a.recommendedQuest, recommendedQuestId = _a.recommendedQuestId;
    return {
        quests: quests,
        recommendedQuest: recommendedQuest,
        recommendedQuestId: recommendedQuestId,
        selectedQuestId: selectedQuestId,
    };
};
var mapDispatch = function (dispatch) { return ({
    onQuestSelect: function (quest) { return dispatch(actionQuestSelect(quest)); },
}); };
export var QuestList = connect(mapState, mapDispatch)(QuestListDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/list/QuestList.tsx
// module id = 2683
// module chunks = 3